import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { findSignatureRequestAct, loadSignatureRequestByIdAct, setViolationsSignatureRequestedAct, showMsgErrorAct, updateSignatureRequestedAct, updateSuccessSignatureRequestedAct } from "./signature-requested.actions";
import { RequestedSignaturesService } from "../../services/requested-signatures.service";
import { Router } from "@angular/router";
import { catchError, exhaustMap, map, of, tap } from "rxjs";
import Swal from "sweetalert2";
import { AlertaService } from "../../services/alerta.service";

@Injectable()
export class RequestedSignaturesEffects {

    private actions$ = inject(Actions);
    private router = inject(Router);
    private requestedSignaturesService = inject(RequestedSignaturesService);
        private alerta = inject(AlertaService);

    findSignatureRequestedEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(findSignatureRequestAct),
            exhaustMap(action => this.requestedSignaturesService.findRequestedSignatureById(action.id)
        .pipe(
            map(signatureRequested => loadSignatureRequestByIdAct({ signatureRequested })),
            catchError(error => of(error))
        ))
        )
    );

    updateSignatureRequestedEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(updateSignatureRequestedAct),
            exhaustMap(action => this.requestedSignaturesService.updateOfferSignatureRequested(action.signatureRequestedUpdated)
                .pipe(
                    map(signatureRequestedUpdated => updateSuccessSignatureRequestedAct({ signatureRequestedUpdated })),
                    catchError(error => (error.status == 400) ? of(setViolationsSignatureRequestedAct({ signatureRequestedForm: action.signatureRequestedUpdated, violations: this.violationsToObject(error.error.parameterViolations) })) : of(showMsgErrorAct({ error }))
                    /*catchError((error) => {
                        if(error.status == 400){
                            return setViolationsUserAct({ userForm: action.userUpdated, violations: this.violationsToObject(error.parameterViolations.violations) });
                        }else{
                            return of(showMsgErrorAct({ error }));
                        }

                    })*/
                    )
                )
            )
        )
    );


    updateSuccessSignatureRequestedEffect$ = createEffect(() => this.actions$.pipe(
        ofType(updateSuccessSignatureRequestedAct),
        tap(() => {
            this.router.navigate(['/requestedSignatures']);

            /*Swal.fire({
                title: "Actualizado!",
                text: "Oferta editado con exito!",
                icon: "success"
            });*/
            this.alerta.correct("Firma actualizada con exito");
        })
    ), {dispatch: false});

    violationsToObject(violationsList: []): any {
        return violationsList.reduce((obj: { [x: string]: any; }, item: { path: string; message: any; }) => {
            obj[item.path.slice(item.path.indexOf('.') + 1)] = item.message;
            return obj;
        }, {});
    };

    showMsgErrorEffect$ = createEffect(() => this.actions$.pipe(
        ofType(showMsgErrorAct),
        tap((action) => {
            /*Swal.fire({
                title: "Error",
                text: "Se ha precentado un error interno: " + action.error.message,
                icon: "error"
            });*/
            this.alerta.error("Se ha precentado un error interno: ", {detail: action.error.message});
        })
    ), { dispatch: false });
}